<div data-target="serviceNotAvailable" cdkTrapFocus>
  <article class="dt-l-article">
    <div class="dt-l-article__content">
      <div class="dt-l-article__section__logo">
        <img [attr.alt]="'UI_COMPANY_LOGO' | translate" src="assets/img/logo-default.png" />
      </div>

      <section class="dt-l-article__section">
        <h1 class="dt-l-article__section__title" tabindex="-1">
          {{ 'UPDATE_REQUIRED_HEADER' | translate }}
        </h1>
        <p class="dt-l-article__section__description" innerHTML="{{ 'UPDATE_REQUIRED_TEXT' | translate }}"></p>
        <button type="button" class="dt-c-button secondary orderButton" (click)="onUpdateButtonClicked()">
          {{ 'UPDATE' | translate }}
        </button>
      </section>
    </div>
  </article>
</div>
